document.addEventListener('DOMContentLoaded', function () {
	const blocks = document.querySelectorAll(
		'.wp-block-myplugin-opening-hours-status'
	);

	blocks.forEach((block) => {
		const badge = block.querySelector('.opening-hours-badge');
		if (!badge) return;

		try {
			const openingHours = JSON.parse(
				block.getAttribute('data-opening-hours')
			);
			const closedDates = JSON.parse(
				block.getAttribute('data-closed-dates')
			);

			updateBadge(badge, openingHours, closedDates);
		} catch (e) {
			console.error('Failed to parse opening hours data.', e);
		}
	});
});

function updateBadge(badgeElement, openingHours, closedDates) {
	const now = new Date();
	// Formatera datum och tid på samma sätt som i PHP
	const todayName = now
		.toLocaleDateString('en-US', { weekday: 'long' })
		.toLowerCase();
	const todayDateStr = now.toISOString().slice(0, 10); // YYYY-MM-DD
	const nowTimeStr = now.toTimeString().slice(0, 5); // HH:MM

	let statusClass = 'is-closed';
	let statusText = 'Stängt';

	if (closedDates.includes(todayDateStr)) {
		// Förblir stängd
	} else {
		const todayHours = openingHours[todayName];
		if (todayHours && todayHours.isOpen && todayHours.open && todayHours.close) {
			const { open, close, lunchStart, lunchEnd } = todayHours;
			
			// Stängningstid - 1 timme
			const closeTimeDate = new Date(`1970-01-01T${close}:00`);
			closeTimeDate.setHours(closeTimeDate.getHours() - 1);
			const closingSoonTime = closeTimeDate.toTimeString().slice(0, 5);

			let isDuringLunch = false;
			if (lunchStart && lunchEnd) {
				if (nowTimeStr >= lunchStart && nowTimeStr < lunchEnd) {
					isDuringLunch = true;
				}
			}

			if (isDuringLunch) {
				statusClass = 'is-closed';
				statusText = 'Stängt för lunch';
			} else if (nowTimeStr >= open && nowTimeStr < close) {
				if (nowTimeStr >= closingSoonTime) {
					statusClass = 'is-closing-soon';
					statusText = 'Stänger snart';
				} else {
					statusClass = 'is-open';
					statusText = 'Öppet';
				}
			}
		}
	}

	// Uppdatera DOM
	badgeElement.textContent = statusText;
	badgeElement.className = `opening-hours-badge ${statusClass}`;
}